import { Suspense } from "react";

import { FiinderProvider } from "./components/fiinder-provider";
import { Widget } from "./components/ui/widget/widget";
import { defaultPersonationContext } from "./lib/personation-context";
import { PdfViewerProvider } from "./components/ui/pdf-viewer/pdf-context";
import { PdfViewer } from "./components/ui/pdf-viewer/pdf-viewer";
import { WidgetOverlayProvider } from "./components/ui/widget/widget-overlay-context";

function App(props: { isLeft?: boolean }) {
  return (
    <Suspense fallback={<div>Loading app...</div>}>
      <FiinderProvider
        fiinderApiUrl={defaultPersonationContext.apiUrl}
        companyToken={defaultPersonationContext.companyToken}
        agentName={defaultPersonationContext.botName}
        agentRole={defaultPersonationContext.botRole}
        agentAvatarUrl={defaultPersonationContext.botAvatarUrl}
        companyMainColor={defaultPersonationContext.companyMainColor}
        introMessage={defaultPersonationContext.introMessage}
        introMessageMeta={defaultPersonationContext.introMessageMeta}
        promptSuggestionsTitle={
          defaultPersonationContext.promptSuggestionsTitle
        }
        promptSuggestions={defaultPersonationContext.promptSuggestions}
        launcherCallToAction={defaultPersonationContext.launcherCallToAction}
        launcherAvatarSize={defaultPersonationContext.launcherAvatarSize}
        linkTarget={defaultPersonationContext.linkTarget}
        searchPlaceholder={defaultPersonationContext.searchPlaceholder}
      >
        <WidgetOverlayProvider>
          <PdfViewerProvider>
            <Widget isLeft={props.isLeft} />
            <PdfViewer />
          </PdfViewerProvider>
        </WidgetOverlayProvider>
      </FiinderProvider>
    </Suspense>
  );
}

export default App;
